"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const createConfig_1 = tslib_1.__importDefault(require("../config/createConfig"));
const createTitle = (options) => {
    const { suffix } = options || (0, createConfig_1.default)().config("title") || {};
    const setTitle = (title) => {
        document.title = `${title}${suffix || ""}`;
    };
    return {
        setTitle,
    };
};
exports.default = createTitle;
//# sourceMappingURL=createTitle.js.map